/**
 * Map3WorkspaceContext
 *
 * Provides workspace-level state from Map3Workspace to descendants that are
 * mounted via React Router's <Outlet /> and cannot receive props directly.
 *
 * viewVisibilityVersion: increments each time the Outlet wrapper transitions
 * from hidden (isNamedView=true) to visible (isNamedView=false). Used as the
 * `key` on Reorder.Group so Framer Motion discards its stale layout-projection
 * cache and does NOT play a fly-in animation when the map body re-appears.
 *
 * Bead: mr-4oag
 */
import React, { createContext, useContext } from 'react';

export type Map3WorkspaceContextValue = {
  /**
   * Increments each time the Outlet wrapper transitions from hidden→visible.
   * Key Reorder.Group on this to reset Framer Motion's projection cache.
   */
  viewVisibilityVersion: number;
};

export const Map3WorkspaceContext = createContext<Map3WorkspaceContextValue>({
  viewVisibilityVersion: 0,
});

export function useMap3WorkspaceContext(): Map3WorkspaceContextValue {
  return useContext(Map3WorkspaceContext);
}
